import axiosInstance from "./AxiosInstance";

export function getAttendanceDataApi(param){
    const fparam=new URLSearchParams(param).toString()
    return axiosInstance.get(`api/attendance?${fparam}`)
}
export function getAttendanceDataExportApi(param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/attendance?${fparam}`, {
    responseType: "blob",
  });
}
export function createAttendanceApi(data){
    return axiosInstance.post('api/attendance',data)
}
export function updateAttendanceApi(data){
    return axiosInstance.patch('api/attendance',data)
}
export function getTodayMarkedApi(){
    return axiosInstance.get('api/attendance/today-marked')
}

export function getEmployeeAttendanceDetails(id,param){
    const fparam=new URLSearchParams(param).toString()
    return axiosInstance.get(`api/attendance-report/${id}/?${fparam}`)
}

export function getEmployeeAttendanceExportApi(id,param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/attendance-report/${id}/?${fparam}`, {
    responseType: "blob",
  });
}